import AxiosApiError from './AxiosApiError'
import {
  PutSelectedRepairShopResponseDto,
  RepairShopSearchDto,
  RepairShopSelectionDto,
} from '@src/model/repairShopDom'
import axiosInstance from './instance'

export const getMatchRepairshopsById = async (id: string | undefined) => {
  try {
    const response = await axiosInstance.get<RepairShopSearchDto>(
      `/public/integ/api/repairshop/match/${id}`,
    )
    return response.data
  } catch (error) {
    throw new AxiosApiError(error)
  }
}
export const putSelectedRepairShop = async (
  uuid: string,
  userData: RepairShopSelectionDto,
) => {
  try {
    const response = await axiosInstance.put<PutSelectedRepairShopResponseDto>(
      `/public/integ/api/repairshop/match/${uuid}`,
      userData,
    )
    return response.data
  } catch (error) {
    throw new AxiosApiError(error)
  }
}
